const module = { name: 'home/desktop.app', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_carousel as fdCarousel } from 'require-global';



import { default as spotlightContent } from 'swug-fdRequire-call:home/desktop/spotlightContent';



import { default as marketingSpotlight } from 'swug-fdRequire-call:shared/desktop/marketingSpotlight';



import { default as theatersModule } from 'swug-fdRequire-call:home/desktop/theatersModule';



import { shared_global_globalTooltipModule as globalTooltipModule } from 'require-global';



import { default as promoCodeTout } from 'swug-fdRequire-call:shared/global/promoCodeTout';



import { default as abTest6254 } from 'swug-fdRequire-call:test/abTest6254';



const Selectors = {
    NAV_CONTAINER: '.nav_container',
}


const Classes = {
    GLOBAL_TOOLTIP_HOME_DESKTOP: 'global-tooltip__container--home-desktop',
}


const carouselOpts = {
    autoWidth: true,
    padding: { left: 0, right: 0 }
}


const tooltipOpts = {
    selector: Selectors.NAV_CONTAINER,
    page: globalTooltipModule.Pages.HOME,
    overrideClass: Classes.GLOBAL_TOOLTIP_HOME_DESKTOP,
    autodismiss: true,
}
function run() {
    checkDependencies(module.name, debugLog);
    fdCarousel.init('movie-carousel', carouselOpts);
    fdCarousel.init('featured-carousel');
    fdCarousel.init('coming-soon-carousel', carouselOpts);
    fdCarousel.init('at-home-carousel', carouselOpts);
    marketingSpotlight.init();
    promoCodeTout.init();
    spotlightContent.init();
    theatersModule.init();
    globalTooltipModule.initOverlay(tooltipOpts);
    abTest6254.run();
}
run();
export default module.exports;